import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DriversPowerSelect from '../drivers/drivers-power-select.jsx';
import 'react-power-select/dist/react-power-select.css';
import CurrencyInput from 'react-currency-input';
import moment from 'moment/moment.js';

export default class PortalJobScheduler extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: props.isLoading || true,
      job: props.data || null,
      jobId: props.jobId || null,
      job_admin_fee_in_pence: props.data.admin_fee_in_pence || null,
      job_admin_fee_in_pence_formatted: null,
      customers: null,
      customer_id: props.data.customer_id || '',
      hasAssignedDriver:props.hasAssignedDriver || false,
      isQuickDriverPlannScreen:props.isQuickDriverPlannScreen || false,
      apiUrlForRemoveDriverFromJob: "/api/v1/portal/jobs/remove-driver-from-job/",
      isZonePage:props.isZonePage || false,
      isLoaderActive:false,
      hasBetaFeatureAccessPrivilege : true,
      driver_id: props.data.driver_id || props.data.saved_driver_id,
      select_all : null,
      fuel_allowance_calculations: ''
    };
    this.handlePickupDateCalendarChange = this.
    handlePickupDateCalendarChange.bind(this);
    this.handleDropoffDateCalendarChange = this.
    handleDropoffDateCalendarChange.bind(this);
    this.handleScheduledPickupDateCalendarChange = this.
    handleScheduledPickupDateCalendarChange.bind(this);
    this.handleScheduledDropoffDateCalendarChange = this.
    handleScheduledDropoffDateCalendarChange.bind(this);

    this.handleDriverSelection = this.
    handleDriverSelection.bind(this);
    this.handleGetDefaultDriverCall = this.handleGetDefaultDriverCall.bind(this);
    this.handleFuelAllowanceChange = this.handleFuelAllowanceChange.bind(this);
  }
  componentDidMount() {
    this.handleBetaFeatureAccessPrivilege();
    this.getCustomersForDropdownMenu();
    this.displayFuelAllowance();
  }
  handleDriverSelection(selectedOption) {
    this.setState({driver_id: selectedOption.driver_id});
  }
  handleBetaFeatureAccessPrivilege(){
    this.setState({
      hasBetaFeatureAccessPrivilege : window.jobs_table_column_toggle_settings.thirdparty_beta_feature_access ? window.jobs_table_column_toggle_settings.thirdparty_beta_feature_access : false
    })
  }
  handleParentUpdatedJob(updatedJob){
    this.setState({job: updatedJob});
    this.setState({driver_id: updatedJob.saved_driver_id});
    this.refs.child.getDefaultDriver();
    console.log('handleParentUpdatedJob',updatedJob.id);
    if(updatedJob.saved_driver === null){
      this.setState({isQuickDriverPlannScreen: false},()=>{
        this.setState({job: updatedJob});
      });
    }else{
      this.setState({isQuickDriverPlannScreen: true},()=>{
        this.setState({job: updatedJob});
      });
    }
  }
  getCustomersForDropdownMenu() {
    let that = this;
    $.ajax({
      url: "/api/v1/portal/customers/all/for-dropdown-menu",
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(customersJson) {
      that.setState({
        customers: customersJson
      });
    });
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      jobId: nextProps.jobId,
      job: nextProps.data,
      isLoading: nextProps.isLoading,
      isQuickDriverPlannScreen: nextProps.isQuickDriverPlannScreen || false,
    });
  }

  handleDropoffDateCalendarChange(date) {
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=dropoff_day]'
    ).value = ("0" + (date.getDate())).slice(-2);
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=dropoff_month]'
    ).value = ("0" + (date.getMonth() + 1)).slice(-2);
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=dropoff_year]'
    ).value = date.getFullYear();
    this.setState({
      dropoff_date: date
    });
  }
  handlePickupDateCalendarChange(date) {
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=pickup_day]'
    ).value = ("0" + (date.getDate())).slice(-2);
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=pickup_month]'
    ).value = ("0" + (date.getMonth() + 1)).slice(-2);
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=pickup_year]'
    ).value = date.getFullYear();
    this.setState({pickup_date: date});
  }
  handleScheduledDropoffDateCalendarChange(date) {
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=scheduled_dropoff_day]'
    ).value = ("0" + (date.getDate())).slice(-2);
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=scheduled_dropoff_month]'
    ).value = ("0" + (date.getMonth() + 1)).slice(-2);
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=scheduled_dropoff_year]'
    ).value = date.getFullYear();
    this.setState({
      scheduled_dropoff_date: date
    });
  }
  handleScheduledPickupDateCalendarChange(date) {
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=scheduled_pickup_day]'
    ).value = ("0" + (date.getDate())).slice(-2);
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=scheduled_pickup_month]'
    ).value = ("0" + (date.getMonth() + 1)).slice(-2);
    document.querySelector(
      '#job-scheduler-for-job-'+this.state.job.id+
      ' select[name=scheduled_pickup_year]'
    ).value = date.getFullYear();
    this.setState({
      scheduled_pickup_date: date
    });
  }
  postData(url = ``, data = {}) {
    return fetch(url, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json'
      },
      redirect: "follow",
      referrer: "no-referrer",
      body: JSON.stringify(data),
    }).
    then(
      response => response //=> response.json()
    );
  }
  handleGetDefaultDriverCall(){
    
    let that = this;
    if(!that.state.driver_id){
      $.ajax({
        url: "/api/v1/portal/drivers/default/for-dropdown-menu/"+that.state.jobId,
        data: {api_token: window.api_token},
        cache: false
      })
      .done(function(defaultDriverJson) {
        that.setState({driver_id: defaultDriverJson.driver_id});
        that.handleJobUpdate(true,true);
      });
    }else{
      that.handleJobUpdate(true,true);
    }
   
  }
  removeDriverFromJob() {
    return fetch(
      this.state.apiUrlForRemoveDriverFromJob+
      this.state.jobId,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        },
      }
    ).then((responseText) => {
        this.props.schedulerHide();
        if(!this.state.isZonePage){
          this.props.isQuickDriverPlannScreenClick();
        }
      }
    );
  }
  handleJobUpdate(
    save = true,
    saveAndSend = false
  ) {
    let savedJobData = {
      api_token: window.api_token,
      job_id: this.state.jobId,
      saved_driver_id: this.state.driver_id,
      driver_id: this.state.driver_id,
      customer_id: this.state.customer_id,

      pickup_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' select[name=pickup_preposition]'
      ).value,
      pickup_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_day]'
      ).value,
      pickup_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_month]'
      ).value,
      pickup_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_year]'
      ).value,
      pickup_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_time]'
      ).value,

      dropoff_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_preposition]'
      ).value,
      dropoff_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_day]'
      ).value,
      dropoff_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_month]'
      ).value,
      dropoff_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_year]'
      ).value,
      dropoff_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_time]'
      ).value,

      scheduled_pickup_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' select[name=scheduled_pickup_preposition]'
      ).value,
      scheduled_pickup_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_pickup_day]'
      ).value,
      scheduled_pickup_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_pickup_month]'
      ).value,
      scheduled_pickup_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_pickup_year]'
      ).value,
      scheduled_pickup_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_pickup_time]'
      ).value,

      scheduled_dropoff_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_preposition]'
      ).value,
      scheduled_dropoff_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_day]'
      ).value,
      scheduled_dropoff_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_month]'
      ).value,
      scheduled_dropoff_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_year]'
      ).value,
      scheduled_dropoff_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_time]'
      ).value,


      customer_order_number: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=customer_order_number]'
      ).value,
      customer_job_number: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=customer_job_number]'
      ).value,

      pin_of_external_system_for_appraisal: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=pin_of_external_system_for_appraisal]'
      ).value,

      fleet_paperwork_required: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=vehicle_fleet_paperwork_required]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=vehicle_fleet_paperwork_required]:checked'
      ).value : this.state.job.fleet_paperwork_required),

      jet_wash_required: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=vehicle_jet_wash_required]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=vehicle_jet_wash_required]:checked'
      ).value : this.state.job.jet_wash_required),

      manual_appraisal_required: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=manual_appraisal_required]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=manual_appraisal_required]:checked'
      ).value : this.state.job.manual_appraisal_required),

      video_appraisal_required: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=video_appraisal_required]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=video_appraisal_required]:checked'
      ).value : this.state.job.video_appraisal_required),

      appraisal_to_be_done_on_external_system: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=appraisal_to_be_done_on_external_system]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=appraisal_to_be_done_on_external_system]:checked'
      ).value : this.state.job.appraisal_to_be_done_on_external_system),

      name_of_external_system_for_appraisal: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=name_of_external_system_for_appraisal]'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=name_of_external_system_for_appraisal]'
      ).value : 0),

      fuel_included_in_job_price: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=driver_fuel_expense_included_in_job_price]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=driver_fuel_expense_included_in_job_price]:checked'
      ).value : this.state.job.fuel_included_in_job_price),
      job_admin_fee_in_pence:this.state.job_admin_fee_in_pence,
      recalculate_latt_and_long: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_latt_and_long'
      ).checked,
      recalculate_distance: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_distance'
      ).checked,
      recalculate_duration: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_duration'
      ).checked,
      recalculate_job_price: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_job_price'
      ).checked,
      recalculate_driver_price: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_driver_price'
      ).checked,
      key_to_key_end_reg: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=key_to_key_end_reg]'
      ).value,
      key_to_key_direction: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=key_to_key_direction]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=key_to_key_direction]:checked'
      ).value : this.state.job.key_to_key_direction),
      
      to_be_invoiced: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=to_be_invoiced]'
      ).value,
      vehicle: {
        type: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_type]'
        ).value,
        make: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_make]'
        ).value,
        colour: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_colour]'
        ).value,
        model: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_model]'
        ).value,
        registration_number: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_registration_number]'
        ).value,
        MOT_passed_at : document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_MOT_passed_at]'
        ).value,
        vin_number: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_vin_number]'
        ).value,
        sliding_door: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_sliding_door]'
        ).value,
        fuel_type: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=fuel_type]'
        ).value,
      },

      special_instructions: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=special_instructions]'
      ).value,
      notes: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=notes]'
      ).value,

      pickup_address: {
        postcode: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_postcode]'
        ).value,
        house_number_or_name: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_house_number_or_name]'
        ).value,
        address_line_1: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_address_line_1]'
        ).value,
        address_line_2: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_address_line_2]'
        ).value,
        address_line_3: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_address_line_3]'
        ).value,
        town_city: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_town_city]'
        ).value,
        county_area: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_county_area]'
        ).value,
        country: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_country]'
        ).value,
        opening_times: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_opening_times]'
        ).value,
        compound_opening_times: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_compound_opening_times]'
        ).value,
        contact_name: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_contact_name]'
        ).value,
        contact_telephone_number: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_contact_telephone_number]'
        ).value,
      },
      dropoff_address: {
        postcode: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_postcode]'
        ).value,
        house_number_or_name: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_house_number_or_name]'
        ).value,
        address_line_1: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_address_line_1]'
        ).value,
        address_line_2: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_address_line_2]'
        ).value,
        address_line_3: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_address_line_3]'
        ).value,
        town_city: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_town_city]'
        ).value,
        county_area: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_county_area]'
        ).value,
        country: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_country]'
        ).value,
        opening_times: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_opening_times]'
        ).value,
        compound_opening_times: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_compound_opening_times]'
        ).value,
        contact_name: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_contact_name]'
        ).value,
        contact_telephone_number: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_contact_telephone_number]'
        ).value,
      },
      release_code: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=release_code]'
      ).value,
      fuel_allowance : document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=fuel_allowance]'
      ).value
    };
    
    if(savedJobData.key_to_key_end_reg != ''){
      alert("By clicking save, job's registration number {"+savedJobData.key_to_key_end_reg+"} will be updated too");
    }

    if ((save === true) && (saveAndSend !== true)) {
      this.postData(
        '/api/v1/portal/jobs/save-job', savedJobData).
      then(response => {
        if(response.status === 200 && this.state.select_all==true){
          this.setState({select_all : false});
          response.json().then(responseText => {
            alert(responseText);
          });
        }
        if(response.status === 200){
          this.props.schedulerHide();
        }
        if (response.status === 400) {
          alert(response.json());
        }
        if (response.status === 403 || response.status === 422) {
          response.json().then(responseText => {
            alert(responseText);
           });
        }
      }).catch(error => {
          console.log(error);
          alert('Error saving job. Please check data and try again.');
        }
      );
    }

    if ((save === true) && (saveAndSend === true)) {
      this.postData('/api/v1/portal/jobs/plan-job', savedJobData).
      then(response => {
        if (response.status === 400 || response.status === 422) {
           response.json().then(responseText => {
            alert(responseText);
           });
        }
        else {
          this.props.schedulerHide();
        }
      }).
      catch(error => {
        console.log(error);
          //alert('error sending job to driver. check data and try again.');
          $('#job-scheduler-modal').modal('modal');
        }
      );
    }
  }
  handleJobDriverUpdateSave(save = true,saveAndSend = false) {
    this.setState({isLoaderActive:true});
    let savedJobDriverData = {
      api_token: window.api_token,
      job_id: this.state.jobId,
      saved_driver_id: this.state.driver_id,
      driver_id: this.state.driver_id,
      customer_id: this.state.customer_id,
      pickup_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' select[name=pickup_preposition]'
      ).value,
      pickup_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_day]'
      ).value,
      pickup_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_month]'
      ).value,
      pickup_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_year]'
      ).value,
      pickup_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_time]'
      ).value,

      dropoff_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_preposition]'
      ).value,
      dropoff_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_day]'
      ).value,
      dropoff_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_month]'
      ).value,
      dropoff_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_year]'
      ).value,
      dropoff_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_time]'
      ).value,

      scheduled_pickup_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' select[name=scheduled_pickup_preposition]'
      ).value,
      scheduled_pickup_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_pickup_day]'
      ).value,
      scheduled_pickup_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_pickup_month]'
      ).value,
      scheduled_pickup_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_pickup_year]'
      ).value,
      scheduled_pickup_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_pickup_time]'
      ).value,

      scheduled_dropoff_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_preposition]'
      ).value,
      scheduled_dropoff_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_day]'
      ).value,
      scheduled_dropoff_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_month]'
      ).value,
      scheduled_dropoff_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_year]'
      ).value,
      scheduled_dropoff_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_time]'
      ).value,


      customer_order_number: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=customer_order_number]'
      ).value,
      customer_job_number: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=customer_job_number]'
      ).value,

      pin_of_external_system_for_appraisal: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=pin_of_external_system_for_appraisal]'
      ).value,

      fleet_paperwork_required: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=vehicle_fleet_paperwork_required]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=vehicle_fleet_paperwork_required]:checked'
      ).value : this.state.job.fleet_paperwork_required),

      jet_wash_required: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=vehicle_jet_wash_required]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=vehicle_jet_wash_required]:checked'
      ).value : this.state.job.jet_wash_required),

      manual_appraisal_required: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=manual_appraisal_required]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=manual_appraisal_required]:checked'
      ).value : this.state.job.manual_appraisal_required),

      video_appraisal_required: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=video_appraisal_required]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=video_appraisal_required]:checked'
      ).value : this.state.job.video_appraisal_required),

      appraisal_to_be_done_on_external_system: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=appraisal_to_be_done_on_external_system]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=appraisal_to_be_done_on_external_system]:checked'
      ).value : this.state.job.appraisal_to_be_done_on_external_system),

      name_of_external_system_for_appraisal: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=name_of_external_system_for_appraisal]'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=name_of_external_system_for_appraisal]'
      ).value : 0),

      fuel_included_in_job_price: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=driver_fuel_expense_included_in_job_price]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=driver_fuel_expense_included_in_job_price]:checked'
      ).value : this.state.job.fuel_included_in_job_price),
      job_admin_fee_in_pence:this.state.job_admin_fee_in_pence,
      recalculate_latt_and_long: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_latt_and_long'
      ).checked,
      recalculate_distance: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_distance'
      ).checked,
      recalculate_duration: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_duration'
      ).checked,
      recalculate_job_price: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_job_price'
      ).checked,
      recalculate_driver_price: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_driver_price'
      ).checked,
      key_to_key_end_reg: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=key_to_key_end_reg]'
      ).value,
      key_to_key_direction: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=key_to_key_direction]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=key_to_key_direction]:checked'
      ).value : this.state.job.key_to_key_direction),

      to_be_invoiced: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=to_be_invoiced]'
      ).value,
      vehicle: {
        type: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_type]'
        ).value,
        make: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_make]'
        ).value,
        colour: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_colour]'
        ).value,
        model: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_model]'
        ).value,
        registration_number: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_registration_number]'
        ).value,
        MOT_passed_at : document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_MOT_passed_at]'
        ).value,
        vin_number: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_vin_number]'
        ).value,
        sliding_door: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_sliding_door]'
        ).value,
        fuel_type: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=fuel_type]'
        ).value,
      },

      special_instructions: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=special_instructions]'
      ).value,
      notes: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=notes]'
      ).value,

      pickup_address: {
        postcode: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_postcode]'
        ).value,
        house_number_or_name: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_house_number_or_name]'
        ).value,
        address_line_1: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_address_line_1]'
        ).value,
        address_line_2: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_address_line_2]'
        ).value,
        address_line_3: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_address_line_3]'
        ).value,
        town_city: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_town_city]'
        ).value,
        county_area: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_county_area]'
        ).value,
        country: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_country]'
        ).value,
        opening_times: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_opening_times]'
        ).value,
        compound_opening_times: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_compound_opening_times]'
        ).value,
        contact_name: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_contact_name]'
        ).value,
        contact_telephone_number: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_contact_telephone_number]'
        ).value,
      },
      dropoff_address: {
        postcode: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_postcode]'
        ).value,
        house_number_or_name: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_house_number_or_name]'
        ).value,
        address_line_1: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_address_line_1]'
        ).value,
        address_line_2: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_address_line_2]'
        ).value,
        address_line_3: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_address_line_3]'
        ).value,
        town_city: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_town_city]'
        ).value,
        county_area: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_county_area]'
        ).value,
        country: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_country]'
        ).value,
        opening_times: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_opening_times]'
        ).value,
        compound_opening_times: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_compound_opening_times]'
        ).value,
        contact_name: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_contact_name]'
        ).value,
        contact_telephone_number: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_contact_telephone_number]'
        ).value,
      },
      release_code: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=release_code]'
      ).value,
      fuel_allowance: document.querySelector(
        '#job-scheduler-for-job-' + this.state.job.id +
        ' [name=fuel_allowance]'
      ).value
      };
    
    if(savedJobDriverData.key_to_key_end_reg != ''){
      alert("By clicking save, job's registration number {"+savedJobDriverData.key_to_key_end_reg+"} will be updated too");
    }  
      
    //if ((save === true) && (saveAndSend === true)) {
      this.postData('/api/v1/portal/jobs/save-job-btn', savedJobDriverData).
      then(response => {
        if (response.status === 400) {
           response.json().then(responseText => {
            alert(responseText);
           });
        }
        else {
          this.props.schedulerHide();
          this.props.isQuickDriverPlannScreenClick();
          this.setState({isLoaderActive:false});
        }
      }).
      catch(error => {
        console.log(error);
          //alert('error sending job to driver. check data and try again.');
          $('#job-scheduler-modal').modal('modal');
        }
      );
   // }
  }
  handleJobDriverUpdate(save = true,saveAndSend = false) {
    this.setState({isLoaderActive:true});
    let savedJobDriverData = {
      api_token: window.api_token,
      job_id: this.state.jobId,
      saved_driver_id: this.state.driver_id,
      driver_id: this.state.driver_id,
      customer_id: this.state.customer_id,
      };

    //if ((save === true) && (saveAndSend === true)) {
      this.postData('/api/v1/portal/jobs/plan-job-and-driver', savedJobDriverData).
      then(response => {
        if (response.status === 400) {
           response.json().then(responseText => {
            alert(responseText);
           });
        }
        else {
          this.props.schedulerHide();
          this.setState({isLoaderActive:false});
        }
      }).
      catch(error => {
        console.log(error);
          //alert('error sending job to driver. check data and try again.');
          $('#job-scheduler-modal').modal('modal');
        }
      );
   // }
  }
  handleKeyToKeyChange(e){
    if(e.target.value == "1"){
      $('.key-to-key-reg-section').removeClass('toggle-hide');
    }else{
      $('.key-to-key-reg-section').addClass('toggle-hide');
    }
  }
  handleSendJobToThirdParty(supplier_company) {
    this.setState({isLoading:true});
    let driver = this.state.driver_id?this.state.driver_id:(this.state.haulier_driver_id?this.state.haulier_driver_id:'');
    let isHaulier = 0;
    this.state.driver_id?isHaulier:isHaulier=1;
    let savedJobData = {
      api_token: window.api_token,
      job_id: this.state.jobId,
      saved_driver_id: driver.toString(),
      driver_id: driver.toString(),
      is_haulier:isHaulier.toString(),
      customer_id: this.state.customer_id.toString(),

      pickup_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' select[name=pickup_preposition]'
      ).value,
      pickup_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_day]'
      ).value,
      pickup_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_month]'
      ).value,
      pickup_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_year]'
      ).value,
      pickup_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=pickup_time]'
      ).value,

      dropoff_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_preposition]'
      ).value,
      dropoff_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_day]'
      ).value,
      dropoff_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_month]'
      ).value,
      dropoff_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_year]'
      ).value,
      dropoff_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=dropoff_time]'
      ).value,

      scheduled_pickup_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' select[name=scheduled_pickup_preposition]'
      ).value,
      scheduled_pickup_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_pickup_day]'
      ).value,
      scheduled_pickup_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_pickup_month]'
      ).value,
      scheduled_pickup_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_pickup_year]'
      ).value,
      scheduled_pickup_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_pickup_time]'
      ).value,

      scheduled_dropoff_preposition: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_preposition]'
      ).value,
      scheduled_dropoff_day: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_day]'
      ).value,
      scheduled_dropoff_month: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_month]'
      ).value,
      scheduled_dropoff_year: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_year]'
      ).value,
      scheduled_dropoff_time: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        '  select[name=scheduled_dropoff_time]'
      ).value,


      customer_order_number: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=customer_order_number]'
      ).value,
      customer_job_number: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=customer_job_number]'
      ).value,

      pin_of_external_system_for_appraisal: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=pin_of_external_system_for_appraisal]'
      ).value,

      fleet_paperwork_required: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=vehicle_fleet_paperwork_required]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=vehicle_fleet_paperwork_required]:checked'
      ).value : this.state.job.fleet_paperwork_required),

      jet_wash_required: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=vehicle_jet_wash_required]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=vehicle_jet_wash_required]:checked'
      ).value : this.state.job.jet_wash_required),

      manual_appraisal_required: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=manual_appraisal_required]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=manual_appraisal_required]:checked'
      ).value : this.state.job.manual_appraisal_required),

      video_appraisal_required: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=video_appraisal_required]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=video_appraisal_required]:checked'
      ).value : this.state.job.video_appraisal_required),

      appraisal_to_be_done_on_external_system: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=appraisal_to_be_done_on_external_system]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=appraisal_to_be_done_on_external_system]:checked'
      ).value : this.state.job.appraisal_to_be_done_on_external_system),

      name_of_external_system_for_appraisal: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=name_of_external_system_for_appraisal]'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=name_of_external_system_for_appraisal]'
      ).value : 0),

      fuel_included_in_job_price: (document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=driver_fuel_expense_included_in_job_price]:checked'
      ) ? document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=driver_fuel_expense_included_in_job_price]:checked'
      ).value : this.state.job.fuel_included_in_job_price),
      job_admin_fee_in_pence:this.state.job_admin_fee_in_pence,
      recalculate_latt_and_long: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_latt_and_long'
      ).checked,
      recalculate_distance: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_distance'
      ).checked,
      recalculate_duration: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_duration'
      ).checked,
      recalculate_job_price: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_job_price'
      ).checked,
      recalculate_driver_price: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' #recalculate_driver_price'
      ).checked,
      key_to_key_end_reg: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=key_to_key_end_reg]'
      ).value,
      to_be_invoiced: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=to_be_invoiced]'
      ).value,
      vehicle: {
        type: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_type]'
        ).value,
        make: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_make]'
        ).value,
        colour: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_colour]'
        ).value,
        model: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_model]'
        ).value,
        registration_number: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_registration_number]'
        ).value,
        MOT_passed_at : document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_MOT_passed_at]'
        ).value,
        vin_number: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_vin_number]'
        ).value,
        sliding_door: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=vehicle_sliding_door]'
        ).value,
        fuel_type: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=fuel_type]'
        ).value,
      },

      special_instructions: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=special_instructions]'
      ).value,
      notes: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=notes]'
      ).value,

      pickup_address: {
        postcode: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_postcode]'
        ).value,
        house_number_or_name: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_house_number_or_name]'
        ).value,
        address_line_1: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_address_line_1]'
        ).value,
        address_line_2: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_address_line_2]'
        ).value,
        address_line_3: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_address_line_3]'
        ).value,
        town_city: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_town_city]'
        ).value,
        county_area: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_county_area]'
        ).value,
        country: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_country]'
        ).value,
        opening_times: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_opening_times]'
        ).value,
        compound_opening_times: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_compound_opening_times]'
        ).value,
        contact_name: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_contact_name]'
        ).value,
        contact_telephone_number: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=pickup_address_contact_telephone_number]'
        ).value,
      },
      dropoff_address: {
        postcode: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_postcode]'
        ).value,
        house_number_or_name: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_house_number_or_name]'
        ).value,
        address_line_1: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_address_line_1]'
        ).value,
        address_line_2: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_address_line_2]'
        ).value,
        address_line_3: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_address_line_3]'
        ).value,
        town_city: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_town_city]'
        ).value,
        county_area: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_county_area]'
        ).value,
        country: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_country]'
        ).value,
        opening_times: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_opening_times]'
        ).value,
        compound_opening_times: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_compound_opening_times]'
        ).value,
        contact_name: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_contact_name]'
        ).value,
        contact_telephone_number: document.querySelector(
          '#job-scheduler-for-job-'+this.state.job.id+
          ' [name=dropoff_address_contact_telephone_number]'
        ).value,
      },
      release_code: document.querySelector(
        '#job-scheduler-for-job-'+this.state.job.id+
        ' [name=release_code]'
      ).value,
      fuel_allowance: document.querySelector(
        '#job-scheduler-for-job-' + this.state.job.id +
        ' [name=fuel_allowance]'
      ).value
    };
      this.postData(
        '/api/v1/portal/jobs/send-job-to-thirdparty-company/'+supplier_company, savedJobData).
      then(response => {
        this.setState({isLoading:false});
        this.props.schedulerHide();
        if (response.status === 400) {
          response.json().then(responseText => {
            alert(responseText);
           });
        }
        if (response.status === 403) {
          response.json().then(responseText => {
            alert(responseText);
           });
        }
        if (response.status === 200) {
          response.json().then(responseText => {
            alert(responseText);
          });
          setTimeout(function(){
            location.reload();
           }, 3000);
          // alert('Job sent to G4');
        }
      }).catch(error => {
          this.setState({isLoading:false});
          console.log(error);
          alert('Error saving job. Please check data and try again.');
        }
      );
  }
  handleDVLALookupClickEvent(e){
    e.preventDefault();
    var VehicleRegistrationNumber = document.getElementById('vehicle_registration_number').value;
    var el = e.target;
    el.disabled = true;
    el.firstChild.classList.remove('d-none');
    return fetch(
      '/api/v1/portal/vehicle/DVLALookup/'+VehicleRegistrationNumber,
      {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json'
        }
      }
    ).then((responseText) => {
        let response = responseText.json();
        let infoModal = $('#infomodal');
        if(responseText.status === 200){
          response.then((resJson) => {
            document.getElementById('vehicle_make').value = resJson['VehicleDetails']['Make'];
            document.getElementById('vehicle_model').value = resJson['VehicleDetails']['Model'];
            document.getElementById('vehicle_colour').value = resJson['VehicleDetails']['Colour'];
            document.getElementById('vehicle_MOT_passed_at').value = resJson['VehicleStatus']['NextMotDueDate'];
            document.getElementById('fuel_type').value = resJson['VehicleDetails']['FuelType'];
            if((resJson['VehicleDetails']['FuelType'].toLowerCase()=='electric') || (resJson['VehicleDetails']['FuelType'].toLowerCase()=='electricity'))
              {
                document.getElementById('fuel_type').style.backgroundColor = "blue";
                document.getElementById('fuel_type').style.color = "white";
              }
              else {
                document.getElementById('fuel_type').style.backgroundColor = "";
                document.getElementById('fuel_type').style.color = "#495057";
              }
            document.querySelector('#infomodallabel').innerHTML = 'Info';
            document.querySelector('#infomodal .modal-body').innerHTML = '<table class="table table-bordered"><tr><th>Make</th> <td>' + resJson['VehicleDetails']['Make'] +'</td></tr>'+
            '<tr><th>Model</th><td>' + resJson['VehicleDetails']['Model'] +'</td></tr>'+
            '<tr><th>Colour</th><td>' + resJson['VehicleDetails']['Colour'] +'</td></tr>'+
            '<tr><th>Next Mot Due Date</th><td>' + resJson['VehicleStatus']['NextMotDueDate'] +'</td></tr></table>';
            infoModal.modal();

            // Below code is to change Background of MOT if date has passed
            const nextMotDueDate = moment(resJson['VehicleStatus'].NextMotDueDate, 'DD/MM/YYYY');
            const currentDate = moment();
            if (nextMotDueDate.isBefore(currentDate)) {
              document.getElementById('vehicle_MOT_passed_at').classList.add('red-bg');
            } else {
              document.getElementById('vehicle_MOT_passed_at').classList.remove('red-bg');
            }
          });
        } else if(responseText.status === 400){
          response.then((resJson) => {
            document.querySelector('#infomodallabel').innerHTML = 'Error';
            document.querySelector('#infomodal .modal-body').innerHTML = resJson.error;
            infoModal.modal();
          });
        }
        el.disabled = false;
        el.firstChild.classList.add('d-none');
    });
  }
  handleSelectAllCheckboxClick = (event) => {
    this.setState({select_all : true});
    const isChecked = event.target.checked;
    const checkboxes = document.querySelectorAll('.recalculate input');
  
    checkboxes.forEach((checkbox) => {
      checkbox.checked = isChecked;
    });
  
    if (isChecked) {
      $('#btn-save-job').click();
    }
  };
  
  handleFuelAllowanceChange = (e) => {
    if (e.target.value !== '') {
      let value = parseFloat(e.target.value) || 0;
      let fuel_allowance_calculations = (value / this.state.job.distance_in_miles).toFixed(2);
      const html = `<strong><i>${this.state.job.distance_in_miles} x £ ${fuel_allowance_calculations}</i></strong>`;
      this.setState({
        fuel_allowance_calculations: html
      });
    }
  };
  displayFuelAllowance() {
    var percentages = parseFloat(this.state.job.fuel_allowance)/this.state.job.distance_in_miles;
    const calculation = `<strong><i>${this.state.job.distance_in_miles} x £ ${percentages.toFixed(2)}</i></strong>`;
    this.setState({ fuel_allowance_calculations: calculation });
  }
  render() {
    let Customers = [];
    if (this.state.customers && this.state.job) {
      this.state.customers.forEach(function (i) {
        Customers.push(
          <option
            key={'customer-'+i.id}
            value={i.id}>
            {i.name}
          </option>);
      });
    }
    return (<div>
      {(this.state.job && this.state.job.id ?
        <div className="job-scheduler-modal">
          <div className="job-scheduler-modal-header">
          </div>
          <div className="job-scheduler-modal-body">
          <form
            id={'job-scheduler-for-job-'+this.state.job.id}
            className="text-left schedule_job_form"
          >
            <fieldset>
              <h1 className="text-right">Job #{this.state.jobId}</h1>
              <div className="row">
                <div
                  className="col-md-4 text-right"
                  style={{'marginTop': '14px'}}>
                  <h2>Driver: </h2>
                </div>
                <div className="col-md-5 drivers-dropdown">
                  <DriversPowerSelect
                    handleDriverSelection={this.handleDriverSelection}
                    job={this.state.job}
                    isZonePage={this.state.isZonePage}
                    ref="child"
                  />
                </div>
                <div className="col-md-3">
                  <div className="text-center">
                    {(!this.state.isQuickDriverPlannScreen ?
                      <button
                        className="btn btn-lg btn-dark pull-right"
                        type="button"
                        data-toggle="collapse"
                        data-target="#scheduler-accordion"
                        aria-expanded="false"
                        aria-controls="scheduler-accordion"
                      ><i className="fa fa-cogs"></i> All Settings <i
                        className="fa fa-plus"></i>
                      </button> : ''
                    )}
                  </div>
                </div>
              </div>
              <br /><br />
              <div className={(!this.state.isQuickDriverPlannScreen) ? 'row' :'row toggle-hide'}>
                <div className="col-md-6">
                <h3>
                  Customer Required Pickup Time <DatePicker
                  customInput={
                    <a className="btn btn-default">
                      <i className="far fa-calendar-alt"></i>
                    </a>
                  }
                  selected={this.state.pickup_date}
                  onChange={this.handlePickupDateCalendarChange}/>
                </h3>
                <div className="input-group">
                  <select name="pickup_preposition" required
                          defaultValue={(this.state.job.pickup_preposition) ?
                            this.state.job.pickup_preposition : ''}
                          className="timedropdown form-control"
                  >
                    <option value="?">?</option>
                    <option value="by">BY</option>
                    <option value="on">ON</option>
                    <option value="from">FROM</option>
                  </select>
                  &nbsp;:&nbsp;

                  <select name="pickup_day" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.pickup_day) ?
                            this.state.job.pickup_day : ''}
                  >
                    <option value="?">?</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                  </select>
                  &nbsp;/&nbsp;
                  <select name="pickup_month" required
                          className="timedropdown form-control"
                          defaultValue={
                            (this.state.job.pickup_month) ?
                            this.state.job.pickup_month : ''
                          }
                  >
                    <option value="?">?</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </select>
                  &nbsp;/&nbsp;

                  <select name="pickup_year" required
                          className="timedropdown form-control"
                          defaultValue={
                            (this.state.job.pickup_year) ?
                            this.state.job.pickup_year : ''
                          }
                  >
                    <option value="?">?</option>
                    <option value="2019">2019</option>
                    <option value="2020">2020</option>
                    <option value="2021">2021</option>
                    <option value="2022">2022</option>
                    <option value="2023">2023</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                  </select>
                  &nbsp;@&nbsp;

                  <select name="pickup_time" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.pickup_time) ?
                            this.state.job.pickup_time : ''
                          }
                  >
                    <option value="?">?</option>
                    <option value="anytime">ANYTIME (9am-5pm)</option>
                    <option value="asap">ASAP</option>
                    <option value="am">AM</option>
                    <option value="pm">PM</option>
                    <option value="0700">7 AM</option>
                    <option value="0730">7:30 AM</option>
                    <option value="0800">8 AM</option>
                    <option value="0830">8:30 AM</option>
                    <option value="0900">9 AM</option>
                    <option value="0930">9:30 AM</option>
                    <option value="1000">10 AM</option>
                    <option value="1030">10:30 AM</option>
                    <option value="1100">11 AM</option>
                    <option value="1130">11:30 AM</option>
                    <option value="1200">12 PM</option>
                    <option value="1230">12:30 PM</option>
                    <option value="1300">1 PM</option>
                    <option value="1330">1:30 PM</option>
                    <option value="1400">2 PM</option>
                    <option value="1430">2:30 PM</option>
                    <option value="1500">3 PM</option>
                    <option value="1530">3:30 PM</option>
                    <option value="1600">4 PM</option>
                    <option value="1630">4:30 PM</option>
                    <option value="1700">5 PM</option>
                    <option value="1730">5:30 PM</option>
                    <option value="1800">6 PM</option>
                    <option value="1830">6:30 PM</option>
                    <option value="1900">7 PM</option>
                    <option value="1930">7:30 PM</option>
                    <option value="2000">8 PM</option>
                    <option value="2030">8:30 PM</option>
                    <option value="2100">9 PM</option>
                    <option value="2130">9:30 PM</option>
                    <option value="2200">10 PM</option>
                    <option value="2230">10:30 PM</option>
                    <option value="2300">11 PM</option>
                    <option value="2330">11:30 PM</option>
                    <option value="0000">MIDNIGHT</option>
                    <option value="1230">12:30 AM</option>
                    <option value="0100">1 AM</option>
                    <option value="0130">1:30 AM</option>
                    <option value="0200">2 AM</option>
                    <option value="0230">2:30 AM</option>
                    <option value="0300">3 AM</option>
                    <option value="0330">3:30 AM</option>
                    <option value="0400">4 AM</option>
                    <option value="0430">4:30 AM</option>
                    <option value="0500">5 AM</option>
                    <option value="0530">5:30 AM</option>
                    <option value="0600">6 AM</option>
                    <option value="0630">6:30 AM</option>
                  </select>
                </div>
                </div>
                <div className="col-md-6">

                <h3>Customer Required Dropoff Time <DatePicker
                  customInput={
                    <a className="btn btn-default">
                      <i className="far fa-calendar-alt"></i>
                    </a>
                  }
                  selected={this.state.dropoff_date}
                  onChange={this.handleDropoffDateCalendarChange}/></h3>
                <div className="input-group">
                  <select name="dropoff_preposition" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.dropoff_preposition) ?
                            this.state.job.dropoff_preposition : ''}
                  >
                    <option value="?">?</option>
                    <option value="by">BY</option>
                    <option value="on">ON</option>
                    <option value="from">FROM</option>
                  </select>
                  &nbsp;:&nbsp;

                  <select name="dropoff_day" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.dropoff_day) ?
                            this.state.job.dropoff_day : ''}
                  >
                    <option value="?">?</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                  </select>
                  &nbsp;/&nbsp;
                  <select name="dropoff_month" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.dropoff_month) ?
                            this.state.job.dropoff_month : ''}
                  >
                    <option value="?">?</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </select>
                  &nbsp;/&nbsp;
                  <select name="dropoff_year" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.dropoff_year) ?
                            this.state.job.dropoff_year : ''}
                  >
                    <option value="?">?</option>
                    <option value="2019">2019</option>
                    <option value="2020">2020</option>
                    <option value="2021">2021</option>
                    <option value="2022">2022</option>
                    <option value="2023">2023</option>
                    <option value="2024">2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                  </select>
                  &nbsp;@&nbsp;
                  <select name="dropoff_time" required
                          className="timedropdown form-control"
                          defaultValue={(this.state.job.dropoff_time) ?
                            this.state.job.dropoff_time : ''}
                  >
                    <option value="?">?</option>
                    <option value="anytime">ANYTIME (9am-5pm)</option>
                    <option value="asap">ASAP</option>
                    <option value="am">AM</option>
                    <option value="pm">PM</option>
                    <option value="0700">7 AM</option>
                    <option value="0730">7:30 AM</option>
                    <option value="0800">8 AM</option>
                    <option value="0830">8:30 AM</option>
                    <option value="0900">9 AM</option>
                    <option value="0930">9:30 AM</option>
                    <option value="1000">10 AM</option>
                    <option value="1030">10:30 AM</option>
                    <option value="1100">11 AM</option>
                    <option value="1130">11:30 AM</option>
                    <option value="1200">12 PM</option>
                    <option value="1230">12:30 PM</option>
                    <option value="1300">1 PM</option>
                    <option value="1330">1:30 PM</option>
                    <option value="1400">2 PM</option>
                    <option value="1430">2:30 PM</option>
                    <option value="1500">3 PM</option>
                    <option value="1530">3:30 PM</option>
                    <option value="1600">4 PM</option>
                    <option value="1630">4:30 PM</option>
                    <option value="1700">5 PM</option>
                    <option value="1730">5:30 PM</option>
                    <option value="1800">6 PM</option>
                    <option value="1830">6:30 PM</option>
                    <option value="1900">7 PM</option>
                    <option value="1930">7:30 PM</option>
                    <option value="2000">8 PM</option>
                    <option value="2030">8:30 PM</option>
                    <option value="2100">9 PM</option>
                    <option value="2130">9:30 PM</option>
                    <option value="2200">10 PM</option>
                    <option value="2230">10:30 PM</option>
                    <option value="2300">11 PM</option>
                    <option value="2330">11:30 PM</option>
                    <option value="0000">MIDNIGHT</option>
                    <option value="1230">12:30 AM</option>
                    <option value="0100">1 AM</option>
                    <option value="0130">1:30 AM</option>
                    <option value="0200">2 AM</option>
                    <option value="0230">2:30 AM</option>
                    <option value="0300">3 AM</option>
                    <option value="0330">3:30 AM</option>
                    <option value="0400">4 AM</option>
                    <option value="0430">4:30 AM</option>
                    <option value="0500">5 AM</option>
                    <option value="0530">5:30 AM</option>
                    <option value="0600">6 AM</option>
                    <option value="0630">6:30 AM</option>
                  </select>
                </div>
                </div>
              </div>
              {(!this.state.isQuickDriverPlannScreen ? <div><br /><br /></div> : '' )}
              <div className={(!this.state.isQuickDriverPlannScreen) ? 'row' :'row'}>
                <div className="col-md-6">
                  <h3>Scheduled Pickup Time <DatePicker
                    customInput={
                      <a className="btn btn-default">
                        <i className="far fa-calendar-alt"></i>
                      </a>
                    }
                    selected={this.state.scheduled_pickup_date}
                    onChange={this.handleScheduledPickupDateCalendarChange}/></h3>
                  <div className="input-group">
                    <select name="scheduled_pickup_preposition" required
                            className="timedropdown form-control"
                            defaultValue='on'
                    >
                      <option value="on">ON</option>
                    </select>
                    &nbsp;:&nbsp;

                    <select name="scheduled_pickup_day" required
                            className="timedropdown form-control"
                            defaultValue={(this.state.job.scheduled_pickup_day) ?
                              this.state.job.scheduled_pickup_day : ''}
                    >
                      <option value="?">?</option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                      <option value="18">18</option>
                      <option value="19">19</option>
                      <option value="20">20</option>
                      <option value="21">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                      <option value="24">24</option>
                      <option value="25">25</option>
                      <option value="26">26</option>
                      <option value="27">27</option>
                      <option value="28">28</option>
                      <option value="29">29</option>
                      <option value="30">30</option>
                      <option value="31">31</option>
                    </select>
                    &nbsp;/&nbsp;
                    <select
                      name="scheduled_pickup_month"
                      required
                      className="timedropdown form-control"
                      defaultValue={(
                        this.state.job.scheduled_pickup_month) ?
                        this.state.job.scheduled_pickup_month : ''
                      }
                    >
                      <option value="?">?</option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                    &nbsp;/&nbsp;

                    <select name="scheduled_pickup_year" required
                            className="timedropdown form-control"
                            defaultValue={(this.state.job.scheduled_pickup_year) ?
                              this.state.job.scheduled_pickup_year : ''}
                    >
                      <option value="?">?</option>
                      <option value="2019">2019</option>
                      <option value="2020">2020</option>
                      <option value="2021">2021</option>
                      <option value="2022">2022</option>
                      <option value="2023">2023</option>
                      <option value="2024">2024</option>
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                    </select>
                    &nbsp;@&nbsp;

                    <select name="scheduled_pickup_time" required
                            className="timedropdown form-control"
                            defaultValue={(this.state.job.scheduled_pickup_time) ?
                              this.state.job.scheduled_pickup_time : ''}
                    >
                      <option value="?">?</option>
                      <option value="anytime">ANYTIME (9am-5pm)</option>
                      <option value="asap">ASAP</option>
                      <option value="am">AM</option>
                      <option value="pm">PM</option>
                      <option value="0700">7 AM</option>
                      <option value="0730">7:30 AM</option>
                      <option value="0800">8 AM</option>
                      <option value="0830">8:30 AM</option>
                      <option value="0900">9 AM</option>
                      <option value="0930">9:30 AM</option>
                      <option value="1000">10 AM</option>
                      <option value="1030">10:30 AM</option>
                      <option value="1100">11 AM</option>
                      <option value="1130">11:30 AM</option>
                      <option value="1200">12 PM</option>
                      <option value="1230">12:30 PM</option>
                      <option value="1300">1 PM</option>
                      <option value="1330">1:30 PM</option>
                      <option value="1400">2 PM</option>
                      <option value="1430">2:30 PM</option>
                      <option value="1500">3 PM</option>
                      <option value="1530">3:30 PM</option>
                      <option value="1600">4 PM</option>
                      <option value="1630">4:30 PM</option>
                      <option value="1700">5 PM</option>
                      <option value="1730">5:30 PM</option>
                      <option value="1800">6 PM</option>
                      <option value="1830">6:30 PM</option>
                      <option value="1900">7 PM</option>
                      <option value="1930">7:30 PM</option>
                      <option value="2000">8 PM</option>
                      <option value="2030">8:30 PM</option>
                      <option value="2100">9 PM</option>
                      <option value="2130">9:30 PM</option>
                      <option value="2200">10 PM</option>
                      <option value="2230">10:30 PM</option>
                      <option value="2300">11 PM</option>
                      <option value="2330">11:30 PM</option>
                      <option value="0000">MIDNIGHT</option>
                      <option value="1230">12:30 AM</option>
                      <option value="0100">1 AM</option>
                      <option value="0130">1:30 AM</option>
                      <option value="0200">2 AM</option>
                      <option value="0230">2:30 AM</option>
                      <option value="0300">3 AM</option>
                      <option value="0330">3:30 AM</option>
                      <option value="0400">4 AM</option>
                      <option value="0430">4:30 AM</option>
                      <option value="0500">5 AM</option>
                      <option value="0530">5:30 AM</option>
                      <option value="0600">6 AM</option>
                      <option value="0630">6:30 AM</option>
                    </select>
                  </div>
                </div>

                <div className="col-md-6">
                  <h3>Scheduled Dropoff Time <DatePicker
                    customInput={
                      <a className="btn btn-default">
                        <i className="far fa-calendar-alt"></i>
                      </a>
                    }
                    selected={this.state.scheduled_dropoff_date}
                    onChange={
                      this.handleScheduledDropoffDateCalendarChange
                    }
                  />
                  </h3>
                  <div className="input-group">
                    <select name="scheduled_dropoff_preposition" required
                            defaultValue='on'
                            className="timedropdown form-control"
                    >
                      <option value="on">ON</option>
                    </select>
                    &nbsp;:&nbsp;

                    <select name="scheduled_dropoff_day" required
                            className="timedropdown form-control"
                            defaultValue={(this.state.job.scheduled_dropoff_day) ?
                              this.state.job.scheduled_dropoff_day : ''}
                    >
                      <option value="?">?</option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                      <option value="18">18</option>
                      <option value="19">19</option>
                      <option value="20">20</option>
                      <option value="21">21</option>
                      <option value="22">22</option>
                      <option value="23">23</option>
                      <option value="24">24</option>
                      <option value="25">25</option>
                      <option value="26">26</option>
                      <option value="27">27</option>
                      <option value="28">28</option>
                      <option value="29">29</option>
                      <option value="30">30</option>
                      <option value="31">31</option>
                    </select>
                    &nbsp;/&nbsp;
                    <select
                      name="scheduled_dropoff_month"
                      required
                      className="timedropdown form-control"
                      defaultValue={(this.state.job.scheduled_dropoff_month) ?
                              this.state.job.scheduled_dropoff_month : ''}
                    >
                      <option value="?">?</option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                    &nbsp;/&nbsp;
                    <select
                      name="scheduled_dropoff_year"
                      required
                      className="timedropdown form-control"
                      defaultValue={(this.state.job.scheduled_dropoff_year) ?
                      this.state.job.scheduled_dropoff_year : ''}
                    >
                      <option value="?">?</option>
                      <option value="2019">2019</option>
                      <option value="2020">2020</option>
                      <option value="2021">2021</option>
                      <option value="2022">2022</option>
                      <option value="2023">2023</option>
                      <option value="2024">2024</option>
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                    </select>
                    &nbsp;@&nbsp;
                    <select
                      name="scheduled_dropoff_time"
                      required
                      className="timedropdown form-control"
                      defaultValue={(this.state.job.scheduled_dropoff_time) ?
                      this.state.job.scheduled_dropoff_time : ''}
                    >
                      <option value="?">?</option>
                      <option value="anytime">ANYTIME (9am-5pm)</option>
                      <option value="asap">ASAP</option>
                      <option value="am">AM</option>
                      <option value="pm">PM</option>
                      <option value="0700">7 AM</option>
                      <option value="0730">7:30 AM</option>
                      <option value="0800">8 AM</option>
                      <option value="0830">8:30 AM</option>
                      <option value="0900">9 AM</option>
                      <option value="0930">9:30 AM</option>
                      <option value="1000">10 AM</option>
                      <option value="1030">10:30 AM</option>
                      <option value="1100">11 AM</option>
                      <option value="1130">11:30 AM</option>
                      <option value="1200">12 PM</option>
                      <option value="1230">12:30 PM</option>
                      <option value="1300">1 PM</option>
                      <option value="1330">1:30 PM</option>
                      <option value="1400">2 PM</option>
                      <option value="1430">2:30 PM</option>
                      <option value="1500">3 PM</option>
                      <option value="1530">3:30 PM</option>
                      <option value="1600">4 PM</option>
                      <option value="1630">4:30 PM</option>
                      <option value="1700">5 PM</option>
                      <option value="1730">5:30 PM</option>
                      <option value="1800">6 PM</option>
                      <option value="1830">6:30 PM</option>
                      <option value="1900">7 PM</option>
                      <option value="1930">7:30 PM</option>
                      <option value="2000">8 PM</option>
                      <option value="2030">8:30 PM</option>
                      <option value="2100">9 PM</option>
                      <option value="2130">9:30 PM</option>
                      <option value="2200">10 PM</option>
                      <option value="2230">10:30 PM</option>
                      <option value="2300">11 PM</option>
                      <option value="2330">11:30 PM</option>
                      <option value="0000">MIDNIGHT</option>
                      <option value="1230">12:30 AM</option>
                      <option value="0100">1 AM</option>
                      <option value="0130">1:30 AM</option>
                      <option value="0200">2 AM</option>
                      <option value="0230">2:30 AM</option>
                      <option value="0300">3 AM</option>
                      <option value="0330">3:30 AM</option>
                      <option value="0400">4 AM</option>
                      <option value="0430">4:30 AM</option>
                      <option value="0500">5 AM</option>
                      <option value="0530">5:30 AM</option>
                      <option value="0600">6 AM</option>
                      <option value="0630">6:30 AM</option>
                    </select>
                  </div>
                </div>
              </div>
              <fieldset class="border p-2 mt-5">
                <legend  class="w-auto">Key To Key</legend>
                <div className="row">
                  <div className="col-md-2">
                    <div className="form-group unit-term-group">
                      <input id="short" className="term-radio-group" type="radio" value="1"
                        defaultChecked={(this.state.job.key_to_key_end_reg && this.state.job.key_to_key_end_reg != null) ? true : false}
                        name="key_to_key_radio" onChange={(e) => this.handleKeyToKeyChange(e)} />
                      <label htmlFor="short" className="radio">
                        &nbsp; &nbsp;Yes &nbsp; &nbsp;
                      </label>
                      <input id="long" className="term-radio-group" type="radio" value="0"
                        defaultChecked={(this.state.job.key_to_key_end_reg && this.state.job.key_to_key_end_reg == null) ? true : false}
                        name="key_to_key_radio" onChange={(e) => this.handleKeyToKeyChange(e)} />
                      <label htmlFor="long" className="radio">
                        &nbsp;&nbsp;No &nbsp; &nbsp;
                      </label>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className={(this.state.job.key_to_key_end_reg && this.state.job.key_to_key_end_reg != null) ? "form-group key-to-key-reg-section" : "form-group key-to-key-reg-section toggle-hide"}>
                      <label>Is this job Outbound or Return?</label>
                      <div className="btn-group btn-group-toggle"
                        id="key-to-key-direction-form-radio-container"
                        data-toggle="buttons">
                        <label className={"btn btn-secondary mt-0" + (this.state.job.key_to_key_direction === "outbound" ? " active" : "")} id="outbound-key-to-key-direction">
                          <input className={"form-control form-control-lg"}
                            defaultChecked={false}
                            name="key_to_key_direction"
                            type="radio"
                            value="outbound" /> Outbound
                        </label>

                        <label className={"btn btn-secondary mt-0" + (this.state.job.key_to_key_direction === "return" ? " active" : "")} id="return-key-to-key-direction">
                          <input className={"form-control form-control-lg"}
                            name="key_to_key_direction"
                            defaultChecked={false}
                            type="radio" value="return" /> Return
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <div className={(this.state.job.key_to_key_end_reg && this.state.job.key_to_key_end_reg != null) ? "form-group key-to-key-reg-section mb-0" : "form-group key-to-key-reg-section  mb-0 toggle-hide"} >
                      <label>What is the reg for other job?</label>
                      <input type="text" className="form-control form-control-lg"
                        placeholder="Enter Reg.."
                        name="key_to_key_end_reg" id="key-to-key-reg"
                        defaultValue={(
                          this.state.job && this.state.job.key_to_key_end_reg) ?
                          this.state.job.key_to_key_end_reg : ''
                        } />
                    </div>
                  </div>
                </div>
              </fieldset>
              {(!this.state.isQuickDriverPlannScreen ? <div><br /><br /></div> : '' )}
              <div id="scheduler-accordion" className="collapse">
                <div className="row">
                  <div className="col-md-2">
                    <h3>Customer</h3>
                    <select
                      className="form-control form-control-lg"
                      name="customer_id"
                      value={this.state.customer_id}
                      onChange={(e) => {
                        this.setState({
                          customer_id: e.target.value
                        });
                      }}>
                      {Customers}
                    </select>
                  </div>
                  <div className="col-md-2">
                    <label>
                      <small>Customer Order Number</small>
                    </label>
                    <input
                      type="text"
                      name="customer_order_number"
                      className="form-control form-control-lg"
                      defaultValue={this.state.job.customer_order_number}
                    />
                  </div>
                  <div className="col-md-2">
                    <label>
                      <small>Customer Job Number</small>
                    </label>
                    <input
                      type="text"
                      name="customer_job_number"
                      className="form-control form-control-lg"
                      defaultValue={this.state.job.customer_job_number}
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Fleet Paperwork required?
                          </label>

                          <div
                            className="btn-group btn-group-toggle"
                            id="fleet-paperwork-form-radio-container"
                            data-toggle="buttons">
                            <label className={"btn btn-secondary" + (
                              this.state.job &&
                              (this.state.job.fleet_paperwork_required === 1)
                                ?
                                ' active '
                                : ''
                            )
                            }
                              id="yes-fleet-paperwork">
                              <input
                                className="form-control form-control-lg"
                                name="vehicle_fleet_paperwork_required"
                                type="radio"
                                value="1"
                                required
                              /> YES
                            </label>
                            <label className={"btn btn-secondary" + (
                              this.state.job &&
                              (this.state.job.fleet_paperwork_required === 0)
                                ?
                                ' active '
                                : ''
                            )
                            }
                                   id="no-fleet-paperwork">
                              <input className="form-control form-control-lg"
                                     name="vehicle_fleet_paperwork_required"
                                     type="radio" value="0" required/> NO
                            </label>
                          </div>
                          <div className="form-group">
                            <label>
                              Jet Wash required?
                            </label>
                            <div
                              className="btn-group btn-group-toggle"
                              id="jet-wash-form-radio-container"
                              data-toggle="buttons">
                              <label className={"btn btn-secondary" + (
                                this.state.job &&
                                this.state.job.jet_wash_required === 1
                                  ?
                                  ' active '
                                  : ''
                              )
                              }
                                     id="yes-jet-wash">
                                <input
                                  className="form-control form-control-lg"
                                  name="vehicle_jet_wash_required"
                                  type="radio"
                                  value="1"
                                  required
                                /> YES
                              </label>
                              <label className={"btn btn-secondary" + (
                                this.state.job &&
                                this.state.job.jet_wash_required === 0
                                  ?
                                  ' active '
                                  : ''
                              )
                              }
                                     id="no-jet-wash">
                                <input
                                  className="form-control form-control-lg"
                                  name="vehicle_jet_wash_required"
                                  type="radio"
                                  value="0"
                                  required
                                /> NO
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <label>
                            Appraisal To Be Done on External System?
                          </label>
                          <div
                            className="btn-group btn-group-toggle"
                            id="appraisal-to-be-done-on-external-system-form-radio-container"
                            data-toggle="buttons">
                            <label className={"btn btn-secondary" + (
                              this.state.job &&
                              this.state.job.appraisal_to_be_done_on_external_system === 1
                                ?
                                ' active '
                                : ''
                            )
                            }
                                   id="yes-appraisal-to-be-done-on-external-system">
                              <input
                                className="form-control form-control-lg"
                                name="appraisal_to_be_done_on_external_system"
                                type="radio"
                                value="1"
                                required
                              /> YES
                            </label>
                            <label
                              className={"btn btn-secondary" + (
                                this.state.job &&
                                this.state.job.appraisal_to_be_done_on_external_system === 0
                                  ?
                                  ' active '
                                  : ''
                              )
                              }
                              id="no-appraisal-to-be-done-on-external-system">
                              <input
                                className="form-control form-control-lg"
                                name="appraisal_to_be_done_on_external_system"
                                type="radio"
                                value="0"
                                required
                              /> NO
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>
                            Manual Appraisal Required?
                          </label>
                          <div
                            className="btn-group btn-group-toggle"
                            id="manual-appraisal-required-form-radio-container"
                            data-toggle="buttons">
                            <label className={"btn btn-secondary" + (
                              this.state.job &&
                              this.state.job.manual_appraisal_required === 1
                                ?
                                ' active '
                                : ''
                            )
                            }
                              id="yes-manual-appraisal-required">
                              <input
                                className="form-control form-control-lg"
                                name="manual_appraisal_required"
                                type="radio"
                                value="1"
                                required
                              /> YES
                            </label>
                            <label
                              className={"btn btn-secondary" + (
                              this.state.job &&
                              this.state.job.manual_appraisal_required === 0
                                ?
                                ' active '
                                : ''
                            )
                            }
                              id="no-manual-appraisal-required">
                              <input
                                className="form-control form-control-lg"
                                name="manual_appraisal_required"
                                type="radio"
                                value="0"
                                required
                              /> NO
                            </label>
                          </div>
                        </div>
                        <div className="form-group">
                          <label>
                            Video Appraisal Required?
                          </label>
                          <div
                            className="btn-group btn-group-toggle"
                            id="video-appraisal-required-form-radio-container"
                            data-toggle="buttons">
                            <label className={"btn btn-secondary" + (
                              this.state.job &&
                              this.state.job.video_appraisal_required === 1
                                ?
                                ' active '
                                : ''
                            )
                            }
                                   id="yes-video-appraisal-required">
                              <input
                                className="form-control form-control-lg"
                                name="video_appraisal_required"
                                type="radio"
                                value="1"
                                required
                              /> YES
                            </label>
                            <label
                              className={"btn btn-secondary" + (
                                this.state.job &&
                                this.state.job.video_appraisal_required === 0
                                  ?
                                  ' active '
                                  : ''
                              )
                              }
                              id="no-video-appraisal-required">
                              <input
                                className="form-control form-control-lg"
                                name="video_appraisal_required"
                                type="radio"
                                value="0"
                                required
                              /> NO
                            </label>
                          </div>
                        </div>
                        
                        <div className="form-group">
                          <label>Name of System for External Appraisal</label>
                          <input
                            type="text"
                            className="form-control form-control-lg"
                            name="name_of_external_system_for_appraisal"
                            defaultValue={this.state.job.name_of_external_system_for_appraisal}
                            />

                        </div>

                        <div className="form-group">
                          <label>
                              External System PIN Number
                          </label>
                          <input
                            type="text"
                            name="pin_of_external_system_for_appraisal"
                            className="form-control form-control-lg"
                            defaultValue={this.state.job.pin_of_external_system_for_appraisal}
                          />
                        </div>

                        <div className="form-group">
                          <label>
                              Release Code
                          </label>
                          <input
                            type="text"
                            name="release_code"
                            className="form-control form-control-lg"
                            defaultValue={(
                              this.state.job &&
                              this.state.job.release_code) ?
                              this.state.job.release_code : ''
                            }
                            id="release_code"
                          />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
                <div className="row row-spacer-1">
                  <div className="col-md-12">
                    <h3>Job Financials</h3>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        Admin Fee
                      </label>
                      <CurrencyInput
                        type="text"
                        name="funds"
                        value={this.state.job_admin_fee_in_pence / 100}
                        prefix={'£'}
                        allowNegative={true}
                        className="form-control form-control-lg form-control-currency"
                        onChangeEvent={
                          (event, maskedValue, floatValue) => {
                            this.setState({
                              job_admin_fee_in_pence: (floatValue * 100),
                              job_admin_fee_in_pence_formatted: maskedValue,
                            });
                          }
                        }
                      />
                    </div>
                  </div>
                  
                  <div className="col-md-3">
                    <div className="form-group text-center">
                      <p>
                        Fuel Included in Job Price?
                      </p>

                      <div
                        className="btn-group btn-group-toggle"
                        id="yes-driver-fuel-expense-included-in-job-price-form-radio-container"
                        data-toggle="buttons">
                        <label className={"btn btn-secondary" + (
                          this.state.job &&
                          this.state.job.fuel_included_in_job_price === 1
                            ?
                            ' active '
                            : ''
                        )
                               }
                               id="yes-driver-fuel-expense-included-in-job-price">
                          <input className="form-control form-control-lg"
                                 name="driver_fuel_expense_included_in_job_price"
                                 type="radio" value="1"/> YES
                        </label>
                        <label className={"btn btn-secondary" + (
                          this.state.job &&
                          this.state.job.fuel_included_in_job_price === 0
                            ?
                            ' active '
                            : ''
                        )
                               }
                               id="no-driver-fuel-expense-included-in-job-price">
                          <input className="form-control form-control-lg"
                                 name="driver_fuel_expense_included_in_job_price"
                                 type="radio" value="0"/> NO
                        </label>
                      </div>
                    </div>
                  </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>
                          Fuel Allowance <i data-toggle="tooltip" title="Only for Gasoline Vehicles" class="fa fa-gas-pump"></i>
                        </label>
                        <input
                          type="text"
                          name="fuel_allowance"
                          className="form-control form-control-lg"
                          defaultValue={this.state.job.fuel_allowance}
                          onChange={this.handleFuelAllowanceChange}
                        />
                      </div>

                      <div className="form-group">
                        <label>Fuel Calculations</label>
                        <div
                          dangerouslySetInnerHTML={{ __html: this.state.fuel_allowance_calculations }}
                        />
                      </div>
                    </div>
                  </div>

                <div className="row">
                  <div className="col-md-12">
                    <br/>
                    <h3>Vehicle Details</h3>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-2">
                    <div className="form-group">
                      <select className="form-control form-control-lg"
                              name="vehicle_type" id="vehicle_type" required
                              defaultValue={(
                                this.state.job.vehicle &&
                                this.state.job.vehicle.type) ?
                                this.state.job.vehicle.type : ''
                              }>
                        <option
                          value="car"
                        >
                          Car
                        </option>
                        <option
                          value="van"
                        >
                          Van
                        </option>
                      </select>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="form-group input-group">
                      <input type="text" placeholder="MOT at" readOnly className="form-control form-control-lg" name="vehicle_MOT_passed_at" id="vehicle_MOT_passed_at" defaultValue={(this.state.job.vehicle && this.state.job.vehicle.MOT_passed_at) ? this.state.job.vehicle.MOT_passed_at : '' }/>
                      <input type="text"
                             className="form-control form-control-lg"
                             placeholder="Number Plate"
                             name="vehicle_registration_number"
                             id="vehicle_registration_number"
                             defaultValue={(
                               this.state.job.vehicle &&
                               this.state.job.vehicle.registration_number) ?
                               this.state.job.vehicle.registration_number : ''
                             }
                             onBlur={(e)=> {e.target.value = e.target.value.replace(/ /g,'')}}/>
                             <div className="input-group-append">
                              <button className="btn btn-outline-secondary" type="button" onClick={this.handleDVLALookupClickEvent}>
                              <span className="spinner-border spinner-border-sm d-none" role="status" aria-hidden="true"></span>
                                &nbsp;&nbsp;&nbsp;DVLA Lookup
                              </button>
                            </div>
                    </div>
                    <div className="form-group">
                      <input type="text" className="form-control form-control-lg"
                             placeholder="VIN Number"
                             name="vehicle_vin_number"
                             defaultValue={(
                               this.state.job.vehicle &&
                               this.state.job.vehicle.vin_number) ?
                               this.state.job.vehicle.vin_number : ''
                             }
                             id="vehicle_vin_number" required/>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <input type="text" className="form-control form-control-lg"
                             placeholder="Make"
                             name="vehicle_make" id="vehicle_make" required
                             defaultValue={(
                               this.state.job.vehicle &&
                               this.state.job.vehicle.make) ?
                               this.state.job.vehicle.make : ''
                             }
                      />
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-group">
                      <input type="text" className="form-control form-control-lg"
                             placeholder="Model"
                             name="vehicle_model" id="vehicle_model" required
                             defaultValue={(
                               this.state.job.vehicle &&
                               this.state.job.vehicle.model) ?
                               this.state.job.vehicle.model : ''
                             }/>
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-group">
                      <input type="text"
                             className="form-control form-control-lg"
                             placeholder="Colour"
                             name="vehicle_colour" id="vehicle_colour" required
                             defaultValue={(
                               this.state.job.vehicle &&
                               this.state.job.vehicle.colour) ?
                               this.state.job.vehicle.colour : ''
                             }/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-2">
                    <div className="form-group">
                      <label htmlFor="vehicle_sliding_door">
                        Vehicle Sliding Door:
                      </label>
                      <select className="form-control form-control-lg"
                              name="vehicle_sliding_door"
                              defaultValue={
                                (this.state.job.vehicle &&
                                  this.state.job.vehicle.sliding_door) ?
                                  this.state.job.vehicle.sliding_door : ''
                              }
                              id="vehicle_sliding_door" required>
                        <option value="not_applicable">N/A</option>
                        <option value="driver_side">Driver Side</option>
                        <option value="passenger_side">Passenger Side</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group section_fuel_type">
                      <input type="text" className="form-control form-control-lg"
                        placeholder="Fuel type" readOnly={true}
                        name="fuel_type" id="fuel_type" 
                        defaultValue={this.state.job?.vehicle?.fuel_type || ""}
                        />
                    </div>
                  </div>
                </div>

                
                <div className="row">
                  <div className="col-md-2 col-md-offset-8">
                    <div className="form-group unit-term-group">
                      <h4>Invoice:</h4>
                      <input id="to_be_invoiced" className="term-radio-group" type="radio" value="1"
                        defaultChecked={this.state.job.to_be_invoiced}
                        name="to_be_invoiced"/>
                        <label htmlFor="to_be_invoiced" className="radio">
                          &nbsp; &nbsp;Yes &nbsp; &nbsp;
                        </label>
                      <input id="not_to_be_invoiced" className="term-radio-group" type="radio" value="0" 
                          defaultChecked={!this.state.job.to_be_invoiced}
                          name="to_be_invoiced"/>
                          <label htmlFor="not_to_be_invoiced" className="radio">
                          &nbsp;&nbsp;No &nbsp; &nbsp;
                          </label>
                    </div>
                  </div>
                </div>

                <br/>
                <div className="row">
                  <div className="col-md-6">
                    <label htmlFor="special_instructions">
                      Special Instructions:
                    </label>
                    <textarea
                      className="form-control form-control-lg text-center"
                      name="special_instructions"
                      defaultValue={this.state.job.special_instructions}
                       id="special_instructions">
                    </textarea>
                  </div>

                  <div className="col-md-6">
                    <label htmlFor="notes">Notes:</label>
                    <textarea
                      className="form-control form-control-lg text-center"
                      name="notes"
                      defaultValue={this.state.job.notes}
                      id="notes">
                    </textarea>
                  </div>
                </div>
                <br /><br />
                <div className="row">
                  <div className="col-md-6">
                    <br/>
                    <br/>
                    <h3>Pickup Address</h3>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_house_number_or_name">
                          House Number or Name:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_house_number_or_name"
                          defaultValue={
                            (this.state.job.pickup_address &&
                             this.state.job.pickup_address.house_number_or_name) ?
                             this.state.job.pickup_address.house_number_or_name : ''
                          }
                          id="pickup_address_house_number_or_name"
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_address_line_1">
                          Address Line 1:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_address_line_1"
                          defaultValue={
                            (this.state.job.pickup_address &&
                              this.state.job.pickup_address.address_line_1) ?
                              this.state.job.pickup_address.address_line_1 : ''
                          }
                          id="pickup_address_address_line_1"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_address_line_2">
                          Address Line 2:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_address_line_2"
                          defaultValue={
                            (this.state.job.pickup_address &&
                              this.state.job.pickup_address.address_line_2) ?
                              this.state.job.pickup_address.address_line_2 : ''
                          }
                          id="pickup_address_address_line_2"
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_address_line_3">
                          Address Line 3:</label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_address_line_3"
                          defaultValue={
                            (this.state.job.pickup_address &&
                             this.state.job.pickup_address.address_line_3) ?
                             this.state.job.pickup_address.address_line_3 : ''
                          }
                          id="pickup_address_address_line_3"
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_town_city">
                          Town/City:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_town_city"
                          defaultValue={
                            (this.state.job.pickup_address &&
                              this.state.job.pickup_address.town_city) ?
                              this.state.job.pickup_address.town_city : ''
                          }
                          id="pickup_address_town_city"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label
                          htmlFor="pickup_address_county_area"
                        >
                          County/Area
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_county_area"
                          defaultValue={
                            (this.state.job.pickup_address &&
                              this.state.job.pickup_address.county_area) ?
                              this.state.job.pickup_address.county_area : ''
                          }
                          id="pickup_address_county_area"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label
                          htmlFor="pickup_address_country"
                          required
                        >
                          Country:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_country"
                          defaultValue={
                            (this.state.job.pickup_address &&
                              this.state.job.pickup_address.country) ?
                              this.state.job.pickup_address.country : ''
                          }
                          id="pickup_address_country"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_postcode">
                          Postcode:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_postcode"
                          defaultValue={
                            (this.state.job.pickup_address &&
                              this.state.job.pickup_address.postcode) ?
                              this.state.job.pickup_address.postcode : ''
                          }
                          id="pickup_address_postcode"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_opening_times">
                          Opening/Closing Times:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_opening_times"
                          defaultValue={
                            (this.state.job.pickup_address &&
                             this.state.job.pickup_address.opening_times) ?
                             this.state.job.pickup_address.opening_times : ''
                          }
                          id="pickup_address_opening_times"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_compound_opening_times">
                          Compound Opening/Closing Times:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_compound_opening_times"
                          defaultValue={
                            (this.state.job.pickup_address &&
                             this.state.job.pickup_address.compound_opening_times) ?
                             this.state.job.pickup_address.compound_opening_times : ''
                          }
                          id="pickup_address_compound_opening_times"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="pickup_address_contact_name">
                          Contact Name:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_contact_name"
                          defaultValue={
                            (this.state.job.pickup_address &&
                             this.state.job.pickup_address.contact_name) ?
                             this.state.job.pickup_address.contact_name : ''
                          }
                          id="pickup_address_contact_name"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label
                          htmlFor="pickup_address_contact_telephone_number"
                        >
                          Contact Telephone Number:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="pickup_address_contact_telephone_number"
                          defaultValue={(
                            this.state.job.pickup_address &&
                            this.state.job.pickup_address.contact_telephone_number) ?
                            this.state.job.pickup_address.contact_telephone_number : ''
                          }
                          id="pickup_address_contact_telephone_number"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <h3>Dropoff Address</h3>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_house_number_or_name">
                          House Number or Name:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_house_number_or_name"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.house_number_or_name) ?
                            this.state.job.dropoff_address.house_number_or_name : ''
                          }
                          id="dropoff_address_house_number_or_name"
                          className="form-control form-control-lg"/>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_address_line_1">
                          Address Line 1:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_address_line_1"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.address_line_1) ?
                            this.state.job.dropoff_address.address_line_1 : ''
                          }
                          id="dropoff_address_address_line_1"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_address_line_2">
                          Address Line 2:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_address_line_2"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.address_line_2)
                            ? this.state.job.dropoff_address.address_line_2
                            : ''
                          }
                          id="dropoff_address_address_line_2"
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_address_line_3">
                          Address Line 3:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_address_line_3"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.address_line_3)
                            ? this.state.job.dropoff_address.address_line_3
                            : ''
                          }
                          id="dropoff_address_address_line_3"
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_town_city">
                          Town/City:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_town_city"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.town_city)
                            ? this.state.job.dropoff_address.town_city
                            : ''
                          }
                          id="dropoff_address_town_city"
                          required
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label
                          htmlFor="dropoff_address_county_area"
                          required
                        >
                          County/Area
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_county_area"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.county_area)
                            ? this.state.job.dropoff_address.county_area
                            : ''
                          }
                          id="dropoff_address_county_area"
                          required
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label
                          htmlFor="dropoff_address_country"
                          required
                        >
                          Country:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_country"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.country)
                            ? this.state.job.dropoff_address.country
                            : ''
                          }
                          id="dropoff_address_country"
                          required
                          className="form-control form-control-lg"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_postcode">
                          Postcode:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_postcode"
                          id="dropoff_address_postcode"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.postcode)
                            ? this.state.job.dropoff_address.postcode
                            : ''
                          }
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <hr />
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_opening_times">
                          Opening/Closing Times:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_opening_times"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.opening_times)
                            ? this.state.job.dropoff_address.opening_times
                            : ''
                          }
                          id="dropoff_address_opening_times"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_compound_opening_times">
                          Compound Opening/Closing Times:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_compound_opening_times"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.compound_opening_times)
                            ? this.state.job.dropoff_address.compound_opening_times
                            : ''
                          }
                          id="dropoff_address_compound_opening_times"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_contact_name">
                          Contact Name:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_contact_name"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.contact_name)
                            ? this.state.job.dropoff_address.contact_name
                            : ''
                          }
                          id="dropoff_address_contact_name"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_contact_telephone_number">
                          Contact Telephone Number:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_contact_telephone_number"
                          defaultValue={(
                            this.state.job.dropoff_address &&
                            this.state.job.dropoff_address.contact_telephone_number)
                            ? this.state.job.dropoff_address.contact_telephone_number
                            : ''
                          }
                          id="dropoff_address_contact_telephone_number"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-center recalculate">
                  <p>
                    <label htmlFor="recalculate_latt_and_long">
                      <input
                        type="checkbox"
                        name="recalculate_latt_and_long"
                        id="recalculate_latt_and_long"
                        defaultChecked={false}
                      /> recalculate latt and long
                    </label>
                  </p>
                  <p>
                    <label htmlFor="recalculate_distance">
                    <input
                      type="checkbox"
                      name="recalculate_distance"
                      id="recalculate_distance"
                      defaultChecked={false}
                    /> recalculate distance
                    </label>
                  </p>
                  <p>
                    <label htmlFor="recalculate_duration">
                    <input
                      type="checkbox"
                      name="recalculate_duration"
                      id="recalculate_duration"
                      defaultChecked={false}
                    /> recalculate duration
                    </label>
                  </p>
                  <p>
                    <label htmlFor="recalculate_job_price">
                      <input
                      type="checkbox"
                      name="recalculate_job_price"
                      id="recalculate_job_price"
                      defaultChecked={false}
                      /> recalculate job price
                    </label>
                  </p>
                  <p>
                    <label htmlFor="recalculate_driver_price">
                    <input
                      type="checkbox"
                      name="recalculate_driver_price"
                      id="recalculate_driver_price"
                      defaultChecked={false}
                    /> recalculate driver price
                    </label>
                  </p>
                  <p>
                  <label htmlFor="select_all">
                    <input
                      type="checkbox"
                      name="select_all"
                      id="select_all"
                      defaultChecked={false}
                      onClick={this.handleSelectAllCheckboxClick}
                    /> select all and save job
                    </label>
                  </p>
                </div>
              </div>
              {(this.state.isQuickDriverPlannScreen ? 
              <div className="scheduler-submit-buttons-container">
                <button
                  className="btn btn-lg btn-danger"
                  onClick={(e) => {this.props.schedulerHide()}}
                  type="button">
                  <i className="fa fa-mobile">
                  </i>&nbsp;
                  HOLD
                </button>&nbsp;&nbsp;&nbsp;
                <button
                  className="btn btn-lg btn-primary"
                  onClick={() =>
                    this.handleJobDriverUpdateSave(true, false)
                  }
                  disabled={(this.state.isLoaderActive) ? true:false}
                  type="button">
                  <i className="fa fa-mobile">
                  </i>&nbsp;
                  Save Job 
                </button>&nbsp;&nbsp;&nbsp;
                <button
                  className="btn btn-lg btn-primary"
                  onClick={() =>
                    this.handleJobDriverUpdate(true, false)
                  }
                  disabled={(this.state.isLoaderActive) ? true:false}
                  type="button">
                  <i className="fa fa-mobile">
                  </i>&nbsp;
                  Change Driver {(this.state.isLoaderActive) ? <i className="fa fa-spinner fa-pulse"></i>:''}
                </button>&nbsp;&nbsp;&nbsp;
                <button
                  className="btn btn-lg btn-success"
                  onClick={() =>
                    this.handleGetDefaultDriverCall()
                  }
                  type="button">
                  <i className="fa fa-mobile">
                  </i>&nbsp;
                  Send Job to Driver
                </button>&nbsp;&nbsp;&nbsp;
                <button
                    className="btn btn-lg btn-dark"
                    onClick={() => {
                      this.removeDriverFromJob()
                    }}
                  >
                    <i className="fa fa-user-times"></i>&nbsp;
                    Remove Driver From Job
                  </button>
                </div> :
              <div className="scheduler-submit-buttons-container">
                <button
                  id = "btn-save-job"
                  className="btn btn-lg btn-primary"
                  onClick={() =>
                    this.handleJobUpdate(true, false)
                  }
                  type="button">
                  <i className="fa fa-save">
                  </i>&nbsp;
                  Save Job
                </button>
                &nbsp;&nbsp;&nbsp;
                <button
                  className="btn btn-lg btn-success"
                  onClick={() =>
                    this.handleJobUpdate(true, true)
                  }
                  type="button">
                  <i className="fa fa-mobile">
                  </i>&nbsp;
                  Save and Send Job to Driver
                </button>
                &nbsp;&nbsp;&nbsp;
                { this.state.hasBetaFeatureAccessPrivilege ? 
                <button 
                  className="btn btn-lg btn-info"
                  onClick={() =>
                    this.handleSendJobToThirdParty('acv')
                  }
                  type="button">
                  <i className="fa fa-mobile">
                  </i>&nbsp;
                  Send Job to ACV
                </button>
               :null }
               &nbsp;&nbsp;&nbsp;
                { this.state.hasBetaFeatureAccessPrivilege ? 
                <button 
                  className="btn btn-lg btn-info"
                  onClick={() =>
                    this.handleSendJobToThirdParty('bvl')
                  }
                  type="button">
                  <i className="fa fa-mobile">
                  </i>&nbsp;
                  Send Job to BVL
                </button>
               :null }
               &nbsp;&nbsp;&nbsp;
                { this.state.hasBetaFeatureAccessPrivilege ? 
                <button 
                  className="btn btn-lg btn-info"
                  onClick={() =>
                    this.handleSendJobToThirdParty('sccd')
                  }
                  type="button">
                  <i className="fa fa-mobile">
                  </i>&nbsp;
                  Send Job to SCCD
                </button>
               :null }
               &nbsp;&nbsp;&nbsp;
                { this.state.hasBetaFeatureAccessPrivilege ? 
                <button 
                  className="btn btn-lg btn-info"
                  onClick={() =>
                    this.handleSendJobToThirdParty('g4')
                  }
                  type="button">
                  <i className="fa fa-mobile">
                  </i>&nbsp;
                  Send Job to G4
                </button>
               :null }
               &nbsp;&nbsp;&nbsp;
                { this.state.hasBetaFeatureAccessPrivilege ? 
                <button 
                  className="btn btn-lg btn-info"
                  onClick={() =>
                    this.handleSendJobToThirdParty('cnd')
                  }
                  type="button">
                  <i className="fa fa-mobile">
                  </i>&nbsp;
                  Send Job to CND
                </button>
               :null }
               &nbsp;&nbsp;&nbsp;
                { this.state.hasBetaFeatureAccessPrivilege ? 
                <button 
                  className="btn btn-lg btn-info"
                  onClick={() =>
                    this.handleSendJobToThirdParty('ivs')
                  }
                  type="button">
                  <i className="fa fa-mobile">
                  </i>&nbsp;
                  Send Job to IVS
                </button>
               :null }
               &nbsp;&nbsp;&nbsp;
                { this.state.hasBetaFeatureAccessPrivilege ? 
                <button 
                  className="btn btn-lg btn-info"
                  onClick={() =>
                    this.handleSendJobToThirdParty('ahvl')
                  }
                  type="button">
                  <i className="fa fa-mobile">
                  </i>&nbsp;
                  Send Job to AHVL
                </button>
               :null }
               &nbsp;&nbsp;&nbsp;
                { this.state.hasBetaFeatureAccessPrivilege ? 
                <button 
                  className="btn btn-lg btn-info"
                  onClick={() =>
                    this.handleSendJobToThirdParty('cargoes')
                  }
                  type="button">
                  <i className="fa fa-mobile">
                  </i>&nbsp;
                  Send Job to AHVL
                </button>
               :null }
              </div>
               )}
              <br/><br/><br/>
            </fieldset>
          </form>
        </div>
      </div> : null)}
    </div>
    );
  }
}